/*
 * <sticky-atc data-after-scroll="true">: fixed add-to-cart bar. With data-after-scroll it is hidden
 * until the main add-to-cart button leaves the viewport. The bar height is exposed as
 * --sticky-atc-offset on <html> so floating buttons can sit above it, and a spacer under the footer
 * keeps the bar from covering the last content.
 */
class StickyAtc extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.afterScroll = this.dataset.afterScroll === 'true';
    this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
    this.spacer = document.querySelector('.sticky-atc-footer-spacer');

    if (this.afterScroll && this.mainButton && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.setVisible(passed);
        },
        { threshold: 0 }
      );
      this.observer.observe(this.mainButton);
    } else {
      this.setVisible(true);
    }

    this.resizeObserver = new ResizeObserver(() => this.updateOffset());
    this.resizeObserver.observe(this);
    this.updateOffset();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.resizeObserver?.disconnect();
    document.documentElement.style.setProperty('--sticky-atc-offset', '0px');
  }

  setVisible(visible) {
    this.classList.toggle('sticky-atc--visible', visible);
    this.updateOffset();
  }

  updateOffset() {
    const visible = !this.afterScroll || this.classList.contains('sticky-atc--visible');
    const height = visible ? this.offsetHeight : 0;
    document.documentElement.style.setProperty('--sticky-atc-offset', `${height}px`);
    document.querySelectorAll('.scroll-to-top-btn, .music-player').forEach((el) => {
      el.style.setProperty('--sticky-atc-offset', `${height}px`);
    });
    if (this.spacer) this.spacer.style.height = `${this.offsetHeight}px`;
  }
}

if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);
